import { $getVehicleTypes } from "@/utils/endpoints";

//TODO REFACTOR FROM store/bookingFunnel.js
//put here every vehicles associated state, getters, mutations, actions

export const state = () => ({
  vehicles: null,
  vehicleTypes: null,
});

const getters = {
  vehicles: (state) => state.vehicles,
  vehicleTypes: (state) => state.vehicleTypes,
};

const mutations = {
  setVehicles: (state, value) => {
    //USED FOR DISPLAYING VEHICLES IN VEHICLE PICKER
    state.vehicles = value;
  },
  setVehicleTypes: (state, value) => {
    // USED FOR DISPLAYING USER'S VEHICLE TYPE
    state.vehicleTypes = value;
  },
};
const actions = {
  getVehicles: async ({ commit }, token) => {
    const res = await $getVehicleTypes(token);
    const customizedVehicles = res
      .map((v) => {
        const isCar = v.type.includes("Auto");
        return {
          ...v,
          customType: isCar ? "Auto" : "Scooter",
          car_id: isCar ? 2 : 1,
        };
      })
      .reduce((filteredVehicleTypes, current) => {
        return !filteredVehicleTypes.some((el) => {
          return el.customType === current.customType;
        })
          ? [...filteredVehicleTypes, current]
          : filteredVehicleTypes;
      }, []);
    commit("setVehicles", customizedVehicles);
  },
  getVehicleTypes: async ({ commit }, token) => {
    const res = await $getVehicleTypes(token);
    commit("setVehicleTypes", res);
  },
};

const namespaced = true;

export default {
  state,
  mutations,
  getters,
  actions,
  namespaced,
};
